/**
 * Full-app error UI for the root Sentry ErrorBoundary (outside Layout).
 * Uses CSS variables from index.css so light/dark stay consistent.
 */
import { Link } from 'react-router-dom';
import { WWW_PAGE_SHELL_MIN_H_CLASS } from '../lib/wwwViewportShell';

/**
 * @param {{ resetError: () => void }} props
 */
export function GlobalErrorFallback({ resetError }) {
  return (
    <div className={`${WWW_PAGE_SHELL_MIN_H_CLASS} flex items-center justify-center px-4 py-10 bg-[var(--bg-primary)] text-[var(--text-primary)]`}>
      <div className="w-full max-w-md text-center space-y-4">
        <h1 className="text-xl font-semibold">Something went wrong</h1>
        <p className="text-sm text-[var(--text-secondary)] leading-relaxed">
          Please try again, refresh the page, or contact support if the problem continues.
        </p>
        <div className="flex flex-col sm:flex-row items-stretch sm:items-center justify-center gap-3 pt-2">
          <button
            type="button"
            onClick={() => resetError()}
            className="btn-primary btn-compact"
          >
            Try again
          </button>
          <button
            type="button"
            onClick={() => window.location.reload()}
            className="btn-secondary btn-compact"
          >
            Reload page
          </button>
          <Link
            to="/login"
            className="btn-secondary btn-compact inline-flex items-center justify-center"
          >
            Back to log in
          </Link>
        </div>
      </div>
    </div>
  );
}
